import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/Home';

const GetAdvertisement = handleActions({
    [Actions.getAdvertisementRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getAdvertisementReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.getAdvertisementReceivedFailured]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.clearAdvertisement]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const LoginOuterServer = handleActions({
    [Actions.loginOuterServerRequest]: () => ({
        isFetching: true,
        data: {},
        errors: {},
    }),
    [Actions.loginOuterServerReceived]: (state, action) => ({
        isFetching: false,
        data: action.payload,
        errors: {},
    }),
    [Actions.loginOuterServerReceivedFailure]: (state, action) => ({
        isFetching: false,
        data: {},
        errors: action.payload.errors,
    }),
    [Actions.clearLoginOuterServer]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

export default combineReducers({
    getAdvertisement: GetAdvertisement,
    loginOuterServer: LoginOuterServer,
});
